import { MatSnackBar } from '@angular/material/snack-bar';

import { Projects, Versions } from '@usimweb/core/models';
import {
  CopyVersionDialogComponent,
  DialogService,
  InfoDialogComponent,
  InputDialogComponent,
} from '@usimweb/ui/dialogs';
import {  AuthHandler } from '@usimweb/core-auth';
import { ApiService } from '@usimweb/core/services';
import * as fromStore from '@usimweb/state/store';

import { Store } from '@ngrx/store';
import { BehaviorSubject } from 'rxjs';
import { Router } from '@angular/router';

export class DialogHandler {
  private store_: Store<fromStore.DashboardState>;
  private dialogService_: DialogService;
  private apiService_: ApiService;
  private snackBar_: MatSnackBar;
  private router_: Router;

  public refreshCallback = new BehaviorSubject<string>('');
  public user!: string;

  constructor(
    store: Store<fromStore.DashboardState>,
    dialogService: DialogService,
    apiService: ApiService,
    snackBar: MatSnackBar,
    router: Router
  ) {
    this.store_ = store;
    this.snackBar_ = snackBar;
    this.dialogService_ = dialogService;
    this.apiService_ = apiService;
    this.router_ = router;
    this.user = AuthHandler.basfUserName.toLocaleLowerCase();
  }

  private openDeleteDialog(version: Versions, uuid: string) {
    this.dialogService_
      .openTextDialog(
        InfoDialogComponent,
        {},
        'Delete project',
        'Delete',
        'Are you sure you want to delete the version?'
      )
      .subscribe((data) => {
        if (data) {
          this.delete(version);
        }
      });
  }

  private openRenameDialog(uuid: string) {
    this.dialogService_
      .openTextDialog(InputDialogComponent, null, 'Rename simulation', 'Rename', '')
      .subscribe((name) => {
        if (name) {
          this.rename(uuid, name);
          this.refreshCallback.next(uuid);
        }
      });
  }

  private openRestartDialog(uuid: string) {
    const subscription = this.apiService_.retryVersion(uuid).subscribe(() => {
      subscription.unsubscribe();

      this.snackBar_.open('Restarted simulation...', 'OK', { duration: 2000 });
      this.refreshCallback.next(uuid);
    });
  }

  private rename(uuid: string, name: string) {
    this.store_.dispatch(new fromStore.RenameVersion({ uuid: uuid, name: name }));
  }

  private delete(obj: Projects | Versions): void {
    const version = obj as Versions;
    this.store_.dispatch(new fromStore.DeleteVersion(version));
  }

  public open(obj: any) {
    //const [dialogEvent, uuid, data] = obj;

    const event = obj.event;
    const uuid = obj.uuid;
    const data = obj.data;

    if (event === 'rename') {
      this.openRenameDialog(uuid);
    }
    if (event === 'delete') {
      this.openDeleteDialog(data, uuid);
    }
    if (event === 'restart') {
      this.openRestartDialog(uuid);
    }
    if (event === 'clone') {
      const project_uuid = obj.data.project;
      this.router_.navigate(['app/newFoaming/' + project_uuid + '/' + uuid]);
    }
    if (event === 'copy') {
      this.dialogService_.openContentDialog(
        CopyVersionDialogComponent,
        { version: uuid },
        'Copy version to project',
        'Copy'
      );
    }
  }
}
